export default () => ({
    currentTab: 0,
    packages: [],
    showAddOn: false,
    open: false,
    addOns: [],
    categories: [],

    init() {
        this.setPackages();

        window.addEventListener('show-add-ons',
            ({ detail }) => this.addOns = detail[0]
        );

        window.addEventListener('packages-loaded', ({ detail }) => {
            this.$store.packages.set(detail[0]);
            this.setPackages();
        });
    },

    setPackages() {
        this.packages = this.$store.packages.all()
            .filter((item) => item.id !== this.$store.cart.mainEvent.no_deposit_package_id);

        this.updateCartValues();

        this.packages?.filter((item) => !item.upsell).forEach((packageItem) => {
            packageItem.template.categories
                ?.filter(({id}) => this.categories.findIndex((category) => category.id === id) === -1)
                .forEach(({id, name}) => {
                    name === 'Prepaid Packages'
                        ? this.categories.unshift({id, name})
                        : this.categories.push({id, name});
                });
        });

        const index = this.categories.findIndex(({ name }) => name === 'Admin');

        if (index !== -1) {
            this.categories.splice(index, 1);
        }

        const firstItem = this.categories[0];

        if(firstItem){
            this.currentTab = firstItem.id;
        }
    },

    currentPackages() {
        return this.packages.filter((item) => !item.upsell).filter(
            ({template}) => template.categories.findIndex(
                ({id}) => id == this.currentTab
            ) > -1
        )
    },

    upsells() {
        return this.packages.filter((item) => item.upsell)
    },

    changeTab(tab) {
        this.currentTab = tab;
    },

    hasRequirements(packageData) {
        return (_.get(packageData.template, 'requirement_images', []) ?? []).length;
    },

    description(description) {
        return description.length < 70 ? description : description.slice(0, 70) + '...';
    },

    flag(item) {
        return !item.template.is_digital && !item.shipping_price ? 'Shipping Included!' : null;
    },

    updateCartValues() {
        for (let index = 0; index < this.$store.cart.items.length; index++) {
            const item = this.packages.find((packageItem) => packageItem.id === this.$store.cart.items[index].package.id);

            if (item) {
                this.$store.cart.items[index].package.name           = item.name;
                this.$store.cart.items[index].package.price          = item.price;
                this.$store.cart.items[index].package.shipping_price = item.shipping_price;
                this.$store.cart.items[index].is_digital             = item.template.is_digital;
            }
        }
    }
});
